import { axios } from '../../services/axios';

export default async function getSRTTrunk(trunkId) {
    const result = await axios.get(`/Trunk/${trunkId}`);
    return result;
}
